import { render, staticRenderFns } from "./ConsultationPay.vue?vue&type=template&id=23792320"
import script from "./ConsultationPay.vue?vue&type=script&lang=js"
export * from "./ConsultationPay.vue?vue&type=script&lang=js"
import style0 from "./ConsultationPay.vue?vue&type=style&index=0&id=23792320&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports